module.exports = __webpack_public_path__ + "media/welcomeBack2.7a27b8f0.mp3";